// @flow

import React, { Component } from 'react';

import AutoCompleteTextInput from './AutoCompleteTextInput';
import ReadOnly from './ReadOnly';

type Props = {
  ariaLabel: string,
  error: string,
  onBlur: () => void,
  onChangeValue: (value: string) => void,
  placeholder: string,
  value: string,
};

type State = {
  hasFocus: boolean,
};

class AutoCompleteTextInputStateful extends Component<Props, State> {
  static defaultProps = {
    onBlur: () => {},
    placeholder: '',
  };

  state = {
    hasFocus: false,
  };

  onFocus = () => {
    this.setState({ hasFocus: true });
  };

  onBlur = () => {
    this.setState({ hasFocus: false }, this.props.onBlur);
  };

  render() {
    const { props, state } = this;

    return state.hasFocus ? (
      <AutoCompleteTextInput
        ariaLabel={props.ariaLabel}
        hasError={!!props.error}
        onBlur={this.onBlur}
        onChangeValue={props.onChangeValue}
        onFocus={this.onFocus}
        placeholder={props.placeholder}
        value={props.value}
      />
    ) : (
      <ReadOnly
        ariaLabel={props.ariaLabel}
        hasError={!!props.error}
        onFocus={this.onFocus}
        placeholder={props.placeholder}
        value={props.value}
      />
    );
  }
}

export default AutoCompleteTextInputStateful;
